export default {
    WEBSOCKET_RETRY_INTERVAL: 5000,
    WEBSOCKET_TIMEOUT: 30000,
    FETCH_ACCOUNT_RETRY_INTERVAL: 5000,
};
